import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useSearchPageContext } from "../Context";
import { withRouter } from "react-router-dom";
import { Map } from "./Map";
import styles from "./Map.module.scss";
import { EMPTY_ARRAY } from "../../Components/misc";
import ReactResizeDetector from "react-resize-detector";
import { SpatialValue } from "./types";
import { event as mapClickEvent } from "../GA/ExploreProviders/MapClick";

// const MAP_MIN_ZOOM_LARGE = 1;
// const MAP_MIN_ZOOM_LARGE = 4.5;
// const MAP_MIN_ZOOM_SMALL = 4.2;
const MAP_MIN_ZOOM_XSMALL = 3.8;
const MAP_MIN_ZOOM_XXSMALL = 0;
const MAP_STRICT_BOUNDS = [138.0322265625, -29.11377539511439, 154.70947265625, -9.611147284770006];
const MAP_LOOSE_BOUNDS_LANDSCAPE = [130.57421875, -29.06597313798418, 157.443359375, -8.390228926463384];
const MAP_LOOSE_BOUNDS_PORTRAIT = [138.57421875, -29.06597313798418, 156.443359375, -7.390228926463384];

// [123.57421875, -29.06597313798418, 164.443359375, -9.690228926463384];

// const MAP_MAX_BOUNDS =
//     // [123.57421875, -35.06597313798418, 164.443359375, -4.390228926463384];
//     [
//         138.0322265625, -29.11377539511439,

//         154.70947265625, -9.602747284770006
//         // -9.535748998133615
//     ];

// [
//     136.0322265625, -30.11377539511439,

//     158.70947265625, -9.602747284770006
//     // -9.535748998133615
// ];

// [130.57421875, -30.06597313798418, 164.443359375, -9.890228926463384];

// [123.57421875, -35.06597313798418, 164.443359375, -4.390228926463384];
const BeforeRouterMap = () => {
    const { metadataWithCount, searchResult } = useSearchPageContext();
    const mapRef = useRef<HTMLDivElement>();
    // const [minZoom, setMinZoom] = useState<number>(undefined);
    // const [maxBounds, setMaxBounds] = useState<number[]>(undefined);
    const [, setRefresh] = useState<{}>({});
    const highlightedProviderAdminIds = useMemo(() => {
        // console.log(searchResult);
        return searchResult?.result?.map(d => d.adminId) ?? (EMPTY_ARRAY as string[]);
    }, [searchResult]);

    const getMaxBounds = useCallback(() => {
        const width = window.innerWidth;

        // 950->max
        // strict bounds

        if (width >= 950) {
            return MAP_STRICT_BOUNDS;
        }
        // 650->950
        // accept extra stuffs

        if (width >= 700) {
            return MAP_LOOSE_BOUNDS_LANDSCAPE;
        }

        if (width >= 650) {
            return MAP_LOOSE_BOUNDS_PORTRAIT;
        }

        if (width >= 300) {
            return MAP_LOOSE_BOUNDS_PORTRAIT;
        }

        // below 650
        // strict bounds

        return MAP_LOOSE_BOUNDS_LANDSCAPE;
    }, []);

    const getMinZoom = useCallback(() => {
        const width = window.innerWidth;

        if (width < 420) {
            return MAP_MIN_ZOOM_XSMALL;
        }

        if (width < 350) {
            return MAP_MIN_ZOOM_XXSMALL;
        }

        return 0;
    }, []);

    const onResize = useCallback(() => {
        if (mapRef?.current) {
            // const width = mapRef?.current?.clientWidth;
            // const height = mapRef?.current?.clientHeight;

            // const parent = mapRef?.current?.parentElement;
            // parent.style.minHeight = `${width / 0.81}px`;

            // if (width >= 600 && height >= 720) {
            //     setMinZoom(MAP_MIN_ZOOM_LARGE);
            // } else if (width < 420) {
            //     setMinZoom(MAP_MIN_ZOOM_XSMALL);
            // } else if (width < 350) {
            //     setMinZoom(MAP_MIN_ZOOM_XXSMALL);
            // } else {
            //     setMinZoom(MAP_MIN_ZOOM_SMALL);
            // }

            // const maxBounds = getMaxBounds();
            // setMaxBounds(maxBounds);
            setRefresh({});
        }
    }, []);

    const onPostFeatureClick: (args: {
        code: string;
        feature: Record<string, unknown>;
        data: SpatialValue;
        value: string;
    }) => void = useCallback(({ data }) => {
        if (data?.name != null) mapClickEvent(data?.name);
    }, []);
    useEffect(() => {
        onResize();
    }, [onResize]);

    const maxBounds = getMaxBounds();
    const minZoom = getMinZoom();
    // console.log(maxBounds);

    return (
        <div className={styles.mapContainer} ref={mapRef}>
            <Map
                // maxBounds={MAP_MAX_BOUNDS}
                maxBounds={maxBounds}
                oceanLayerDisplay={false}
                labelLayerDisplay={true}
                metadata={metadataWithCount}
                // minZoom={minZoom}
                minZoom={minZoom}
                highlightedProviderAdminIds={highlightedProviderAdminIds}
                onPostFeatureClick={onPostFeatureClick}
            />
            <ReactResizeDetector handleWidth={true} onResize={onResize}></ReactResizeDetector>
        </div>
    );
};

export const SearchPageMap = withRouter(BeforeRouterMap);
